import type { MatterStatus } from '~/gql/graphql';
import type { MatterViewModel } from '~/modules/matters/matters.types';
import type { User } from '~/shared/types/connect';
import type { MattersTabValue } from '~/shared/types';

/**
 * Per-expert rollup for matter cards (derived from retainers + participation).
 * Not the same as GraphQL `RetainerStatus` on a single `Retainer` row — use `~/gql/graphql` for that.
 */
export enum ExpertRetainerRollupStatus {
  PendingApproval = 'pending-approval',
  WaitingRequest = 'waiting-request',
  Active = 'active',
  Completed = 'completed',
}

export interface ExpertRetainerStatus {
  expertId: string;
  status: ExpertRetainerRollupStatus;
}

export interface Props {
  matter: MatterViewModel;
  otherParty: User | null;
  totalBilled: number;
  hasPendingRetainer: boolean;
  isPendingRetainerInitiatedByExpert?: boolean;
  hasFundedRetainer: boolean;
  isAttorneyView: boolean;
  matterTab?: MattersTabValue;
  activeRetainerAmount?: string;
  activeRetainerCount?: number;
  experts?: User[];
  expertRetainerStatuses?: ExpertRetainerStatus[];
  otherPartyRetainerStatus?: ExpertRetainerRollupStatus;
  onRequestRetainer?: (matter: MatterViewModel) => void;
  onReopenMatter?: (matter: MatterViewModel) => void;
  onAcceptRetainerRequest?: (matter: MatterViewModel) => void;
  /** When provided, a status dropdown is shown so the user can change matter status from the card. */
  onStatusChange?: (matter: MatterViewModel, value: MatterStatus) => void;
}
